<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar class="segment-card" slot="bottom" v-show="showTab" v-if="userInfo.user?.role === 'assistant'">
        <ion-tab-button tab="tab3" href="/tabs/tab3">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_otherclass.svg" />
          <ion-label>課程</ion-label>
        </ion-tab-button>
        <ion-tab-button tab="tab6" href="/tabs/tab6">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_setting.svg" />
          <ion-label>設定</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
      <ion-tab-bar class="segment-card" slot="bottom" v-show="showTab" v-else-if="appStore.getRole === ''">
        <ion-tab-button tab="tab1" href="/tabs/tab1">
          <ion-icon name="list-sharp" color="primary" />
          <ion-label>總表</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/tabs/tab2">
          <ion-badge color="danger" v-if="notificationCount > 0">{{ notificationCount }}</ion-badge>
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_feed.svg" />
          <ion-label>學生近況</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" href="/tabs/tab3">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_otherclass.svg" />
          <ion-label>課程</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" href="/tabs/tab4">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_class.svg" />
          <ion-label>我的班級</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab5" href="/tabs/tab5">
          <ion-icon name="cash-outline" color="primary" />
          <ion-label>繳費(測試)</ion-label>
        </ion-tab-button>

        <!-- <ion-tab-button tab="tab2" href="/tabs/tab3/tutor">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_otherclass.svg" />
          <ion-label>未繳費名單</ion-label>
        </ion-tab-button> -->

        <ion-tab-button tab="tab6" href="/tabs/tab6">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_setting.svg" />
          <ion-label>設定</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
      <ion-tab-bar class="segment-card mangerColor" slot="bottom" v-show="showTab" v-else>
        <ion-tab-button tab="tab1" href="/tabs/manager/tabA" class="mangerColor">
          <ion-icon name="book-outline" color="primary"  />
          <ion-label>課程</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/tabs/manager/tabB" class="mangerColor">
          <ion-badge color="danger" v-if="notificationCount > 0">{{ notificationCount }}</ion-badge>
          <ion-icon name="man-outline" color="primary"  />
          <ion-label>教師</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab3" href="/tabs/manager/tabC" class="mangerColor">
          <ion-icon name="people-outline" color="primary"  />
          <ion-label>學生</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab4" href="/tabs/manager/tabD" class="mangerColor">
          <ion-icon name="cash-outline" color="primary" />
          <ion-label>部門繳費(測試)</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab6" href="/tabs/tab6" class="mangerColor">
          <ion-icon aria-hidden="true" src="/assets/images/svg/tools_icon_setting.svg" />
          <ion-label>設定</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import api from '@/api';
import { useRoute } from 'vue-router';
import { useAppStore } from '@/store/modules/app'

const route = useRoute()
const notificationCount = ref(0)

const showTab = ref(true)
const appStore = useAppStore()
const userInfo = ref(appStore.getUserInfo)

watch(() => route.fullPath, async (val) => {
  notificationCount.value = await api.notification.getNotificationCount()
  userInfo.value = appStore.getUserInfo

  // showTab.value = (val !== '/tabs/tab1')

}, { immediate: true })

</script>

<style>
ion-tab-button {
  ion-icon {
    font-size: 32px;
  }

  ion-label {
    font-size: 12px;
  }
}

ion-tab-bar {
  height: 70px;
}

.segment-card {
  display: flex;
  overflow-x: scroll;

  .segment-item {
    display: inline-block !important;
    min-width: 100px !important;
    width: auto !important;
  }
}

.mangerColor {
  background-color: rgb(195 225 243);
}
</style>